import { render } from "./CustomerBusinessDetails.vue?vue&type=template&id=769d85f3&scoped=true"
import script from "./CustomerBusinessDetails.vue?vue&type=script&lang=js"
export * from "./CustomerBusinessDetails.vue?vue&type=script&lang=js"

import "./CustomerBusinessDetails.vue?vue&type=style&index=0&id=769d85f3&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-769d85f3"]])

export default __exports__